import { Dashboard } from 'components/Layout';
import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import api from 'api/api';
import { compose } from 'ramda';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import { OrganizationType } from 'store/modules/organizations/organizations';
import Users from 'components/OrganizationAdmin/Groups/GroupShared/Users';
import Menu, { Tab } from './Menu';
import Projects from 'components/OrganizationAdmin/Groups/GroupShared/Projects';
import { BackTo } from '@deeptrue-frontend/ui';
import ROUTES from 'consts/routing';
import { GroupShared } from 'pages/OrganizationAdmin/types';
import Products from 'components/OrganizationAdmin/Groups/GroupShared/Products';
import queryString from 'query-string';
import { useFormatMessage } from 'components/IntlProvider';

const { connect, selectors } = StoreProvider;

interface Props extends RouteComponentProps {
  organization: OrganizationType;
  match: {
    isExact: boolean;
    path: string;
    url: string;
    params: {
      id: string;
    };
  };
}

const GroupSharingPage = ({
  location,
  organization,
  match,
  history,
}: Props) => {
  const t = useFormatMessage();
  const [tab, selectTab] = useState<Tab>(
    (queryString.parse(location.search) as { tab: Tab }).tab
  );

  const [groupData, setGroupData] = useState<GroupShared>({
    id: undefined,
    name: '',
    users: [],
    shared_projects: [],
    shared_products: [],
  });
  const [isLoaded, setIsLoaded] = useState(false);
  const { id } = match.params;

  const getGroup = () => {
    return api.resources.organization.groups
      .getGroup({
        organizationCodename: organization.codename,
        groupId: id,
      })
      .then(({ data }: { data: GroupShared }) => {
        setGroupData({ ...data });
      })
      .finally(() => {
        setIsLoaded(true);
      });
  };

  useEffect(() => {
    getGroup();
    // eslint-disable-next-line
  }, []);

  return (
    <Dashboard
      title={`Admin / ${groupData.name} ${t('organization.group', 'Group')} `}
      location={location}
    >
      <BackTo onClick={() => history.push(ROUTES.ORGANIZATION.ADMIN.GROUPS)}>
        <span>
          {`${t('organization.backTo', 'Back to')} ${t(
            'organization.groups',
            'Groups'
          )}`}
        </span>
      </BackTo>
      <Menu tab={tab} selectTab={selectTab} />
      {tab === 'users' && (
        <Users
          organizationCodename={organization.codename}
          groupData={groupData}
          isLoaded={isLoaded}
          updateGroup={setGroupData}
        />
      )}
      {tab === 'projects' && (
        <Projects
          groupData={groupData}
          isLoaded={isLoaded}
          organizationCodename={organization.codename}
          refreshGroup={getGroup}
        />
      )}
      {tab === 'products' && (
        <Products
          groupData={groupData}
          isLoaded={isLoaded}
          organizationCodename={organization.codename}
          refreshGroup={getGroup}
        />
      )}
    </Dashboard>
  );
};

export default compose(
  connect((state) => ({
    organization: selectors.authSelectors.userOrganization(state),
    isAdmin: selectors.authSelectors.isOrganizationAdmin(state),
  }))
)(GroupSharingPage);
